export default __webpack_public_path__ + "static/media/AppStr.f5760726.png";